import React from "react"
import { Link } from "gatsby"
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'

const Navigation = () =>  {


return (
<Navbar expand="lg" className='' variant="dark" bg="none">
  <Navbar.Brand href="/" id="brandname" >NAREN KATAKAM</Navbar.Brand>
  <Navbar.Toggle aria-controls="basic-navbar-nav" id="toggler" variant="light"/>
  <Navbar.Collapse id="basic-navbar-nav">
  {/* <Link to='/' id="closebtn" >&times;</Link>  */}
    <Nav className="ml-auto" id="overlay" >
      <Link
      to="/"
      activeStyle={{ color: "#ffd300" ,borderBottom: "3px solid #ffd300"}}
      style={{color:"#fff" }}
      id="linkstyle"
      >
      Home
      </Link>

      <Link
      to="/design/"
      activeStyle={{ color: "#ffd300", borderBottom: "3px solid #ffd300"}}
      style={{color:"#fff"}}
      partiallyActive={true}
      id="linkstyle"
      >
      Design
      </Link>

      <Link
      to="/product/"
      activeStyle={{ color: "#ffd300" ,borderBottom: "3px solid #ffd300"}}
      style={{color:"#fff"}}
      partiallyActive={true}
      id="linkstyle"
      >
      Product
      </Link>

      <Link
      to="/about"
      activeStyle={{ color: "#ffd300" , borderBottom: "3px solid #ffd300" }}
      style={{color:"#fff" }}
      id="linkstyle"
      >
      About
      </Link>
    </Nav>

  </Navbar.Collapse>
</Navbar>

)

}

export default Navigation

// https://peterhironaka.com/how-to-create-a-sliding-navigation-with-react-hooks
//https://github.com/negomi/react-burger-menu#animations